import { getTranslate } from 'legacy-src/utilities/i18n'
import React from 'react'

import { ButtonLink } from '@/legacy-src/components/ui/button'
import { cn } from '@/legacy-src/lib/utils'

import { type TherapistType } from '../../../types/TherapistStateType'
import TherapistBubbles from '../../TherapistBubbles'

type Props = {
  readonly therapists: TherapistType[]
  readonly isLoggedIn: boolean
  readonly className?: string
  readonly vertical?: boolean
  readonly title?: string
  readonly ctaOverride?: { href: string; text: string }
}

const DiagnosisTeaserContent: React.FC<Props> = ({
  therapists = [],
  isLoggedIn,
  className,
  vertical = false,
  title,
  ctaOverride,
}) => {
  const { t } = getTranslate()

  const href = ctaOverride?.href || (isLoggedIn ? '/client/diagnosis' : '/diagnosis')

  return (
    <div className={cn('flex w-full justify-center', className)}>
      <div className={cn('w-full bg-blue-500', vertical ? 'rounded-3xl p-10' : 'rounded-xl px-5 py-4')}>
        <div
          className={cn(
            '-m-3 flex flex-col items-center justify-between',
            vertical ? 'tablet:flex-column' : 'tablet:flex-row',
          )}
        >
          <TherapistBubbles {...{ therapists }} sizeClass={vertical ? 'w-14 h-14' : undefined} />
          <div
            className={cn(
              'mb-0 p-3 text-center font-serif text-xl font-bold leading-6',
              vertical ? 'mb-0 tablet:!text-center' : 'tablet:!text-left',
            )}
          >
            {title || t('component.diagnosisIntro.title')}
          </div>
          <div className="flex-shrink-0 p-3">
            <ButtonLink size={vertical ? 'medium' : 'small'} href={href}>
              {ctaOverride?.text || t('component.button.findTherapist')}
            </ButtonLink>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DiagnosisTeaserContent
